import requestData, {setFormData,setURLSearchParams,middleErrorInfo,formatterData} from "../../../http/request";
const thisFile = 'Shop.js';
const shoppingCart = 'shoppingCart'.toLowerCase();
function shopDetailFormatter(item) {
    return {
        id:item.id,
        partName: item['part_name'],
        suitableModel: item['suitable_model'],
        unit: item.unit,
        parentCode: item.parentCode,
        oeCode: item['oem']?item['oem']:item['oecode1'],
        originPrice:item.price,
        discountPrice:item['discount_price'],
        isFavorite:Boolean(parseInt(item['isFavorites'])),
        isOnline:String(item.isOnline)?Boolean(Number(item.isOnline)):process.env.NODE_ENV==='development',
        part_id:item.part_id,
        pics:item.pics,
        product_code:item.product_code,
        remark:item.remark,
    }
}
/**
 * 分类层级接口
 * @param id
 * @returns {Promise<then>}
 */
export const getPartLevelRequest = (page=1,pageSize=8) =>{
    return new Promise((resolve, reject) => {
        requestData('/shop/parts/getPartTypeToTypeList?is_pc=1','GET',{page,pageSize}).then(res=>{
            if(res.data.code==-1) return resolve(formatterData({
                status:res.data.code,
                errorMessage:res.data.msg
            }));
            const data = formatterData({
                status:200,
                dataArray:Object.entries(res.data.data).map(i=>i[1]).map(item=>{return{
                    id:item.pt_id,
                    typeName:item['pt_name'],
                    isType:item.isType,
                    // sortLevel:Number(item.sortLevel),
                    typeItems:item['childList'] && item['childList'].map(({part_id,pics,pt_name,pt_id,unit,price,oecode1,product_code,remark})=>({
                        remark,
                        product_code,
                        oeCode:oecode1,
                        part_id,
                        // sortLevel:Number(item.sortLevel),
                        // isOnline:process.env.NODE_ENV==='development' ||String(item.isOnline)?Boolean(Number(item.isOnline)):false,
                        isOnline: true,
                        img:pics,
                        category:pt_name,
                        // code:item.code,
                        id:pt_id,
                        unit,
                        price,
                    }))
                }})
                
            })
            data['typeList'] = res.data.typeList
            data['page'] = res.data.page
            data['pageSize'] = res.data.pageSize
            data['total_page'] = res.data.total_page
            resolve(data);
        }).catch(reason => {
            console.trace({
                message:`Middle error ${thisFile} getPartLevelRequest`,
                reason
            });
            reject(reason);
        })
    })
}
/**
 * 获取商品详情
 * @param typeId    分类ID
 * @param type      父级编号
 * @param pageSize  页码大小
 * @param page      第几页
 * @param keys      搜索内容
 * @returns {Promise<then>|Promise<catch>}
 */
/*,type='',pageSize=100,page=1,keys=''*/
export const getShopDetail = ({typeId=0, page=1,pageSize=20,}) =>{
    /*keys = keys.trim();
    if(!type && !keys) return Promise.reject({errorMessage:'无获取到产品身份标识'});*/
    const params = {
        pageSize,
        page,
        typeId
    };
    /*if(type)params['type'] = type;*/
    /*if(keys)params['keys'] = keys;*/
    return new Promise((resolve, reject) => {
        const resolveData = {
            listInfo:[]
        };
        requestData('/shop/parts/getPartListByType','GET', params,).then(res=>{
            resolveData.listInfo = res.data.data.map(shopDetailFormatter);
            resolveData.page_conf = res.data.page_conf;
            resolve(resolveData);
        }).catch(reason => {
            console.trace('Middle error SelfOperatedMallRequest getShopDetail: '+JSON.stringify(reason));
            reject({reason});
        })
    })
}
/*
   根据vin码搜索车型信息 必传参数：vin
*/
export const searchVin = (vin='')=>{
    return requestData('/shop/searchvin/getVinCarInfo','POST',{vin});
}
export const getBrandParts = ({brandname='', familyname='', groupname='', modelname='', vin='', year='', disp='', drive='', modelId='',pt_id=0})=>{

    return new Promise((resolve, reject) => {
        const data = {brandname,familyname,groupname,modelname,vin,year,disp,drive,modelId};
        pt_id?data['pt_id']=pt_id:null;
        requestData('/shop/Searchvin/getBrandParts','POST', data).then(result=>{
            const resultData= result.data;
            if(!resultData.data || !resultData.data.length) resultData.data=[];
            resolve({
                ...resultData,
                listInfo:resultData.data.map(shopDetailFormatter)
            });
        }).catch(r=>reject(r));
    })
}
export const getOecodeParts = function (oecode='') {
    return new Promise((resolve, reject) => {
        requestData('/shop/searchvin/getOecodeParts','POST',{oecode}).then(r=> {
            const resultData= r.data;
            resolve({
                ...resultData,
                listInfo:resultData.data?resultData.data.map(shopDetailFormatter):[]
            });
        }).catch(r=>reject(r));
    })
}
export const getBrandPartsProductCode= function ({product_code}) {
    return new Promise((resolve, reject) => {
        requestData('/shop/searchvin/getBrandParts','POST',{product_code}).then(r=> {
            const resultData= r.data;
            resolve({
                ...resultData,
                listInfo:resultData.data?resultData.data.map(shopDetailFormatter):[]
            });
        }).catch(r=>reject(r));
    })
}

export const queryBrandOfCarModel = function ({capital='常用',lang='zh-CN'}) {
    return requestData('/shop/maintain/queryBrand','POST',{capital,lang});
}
//车系、车组
export function autoChildByFid(ppid=''){
    return requestData('/shop/maintain/autoChildByFid','POST',{ppid});
}
//根据车系id查询汽车车组信息
export function getCarSetChildByPid(cxiId=0){
    return requestData('/shop/maintain/getCarSetChildByPid','POST',{cxiId});
}
//根据车组id查询汽车详细车型集合
export function getCarSetChildByPidForMobile(czId=0) {
    return requestData('/shop/maintain/getCarSetChildByPidForMobile','POST',{czId})
}
export function saveCartRequest(pid = 0,num=1,type=0) {
    const data = {pid,num};
    type?data['type']=type:0;
    return requestData('/shop/shopping/addCart','POST',data);
}
export function getCartRequest(page=1,pageSize=20,addressId) {
    return requestData('/shop/shopping/getCart','POST',{page,pageSize,addressId});
}
export function deleteCartItemRequest(shoppingId = 0) {
    if(!shoppingId) return;
    return requestData('/shop/shopping/delCart','POST',{shoppingId});
}
export function updateCartNum(shoppingId=0,needUpdateNum=1){
    return requestData('/shop/shopping/updateCartNum','POST',{shoppingId,needUpdateNum})
}
export function noticeList(){
    return requestData('/shop/notice/noticeList');
}
export function getOneNoticeInfo(id=0){
    if(!id) return;
    return requestData('/shop/notice/getOneNoticeInfo','POST',{id});
}

/**
 * 通过图片识别出Vin码
 * @param type 1行驶证 0非行驶证
 * @param ali 第一次0 第二次1
 * @param image base64
 * @returns {AxiosPromise}
 */
export function identify(type=1,ali=0,image=''){
    const data = {type,ali,image};
    type==1?data['request_form']=1:null;
    return requestData('/Appapi/Youtu/OCR20200701','POST',data);
}
export function getPartDetails(partId=0){
    if(!partId) return;
    return requestData('/shop/parts/getPartDetails','POST',{partId});
}

export function getLatestPartData(shopId=''){
    if(!shopId) return;
    return requestData('/shop/parts/getLatestPartData','POST',{shopId});
}

export function getMorePartList(typeId,page,pageSize){
    if(!typeId) return Promise.reject({message:'typeId is not normal: '+typeId});
    return requestData('/shop/parts/getMorePartList','POST',{typeId,page,pageSize});
}
export function queryGoodsInventoryOfRegion(addressId=0,erp_goods_id=0){
    if([addressId,erp_goods_id].some(i=>!i)) return;
    return requestData('/shop/shopping/queryGoodsInventoryOfRegion','POST',{addressId,erp_goods_id});
}
export function createOrderPageApi(shopId=[]){
    if(!shopId || !shopId.length) return Promise.reject({message:'shopId is not normal:'+shopId});
    return requestData('/shop/order/createOrderPageApi','GET',{shopId});
}
export function addOrderApi(shippingAddressId=0,shopId=[],isNeedInvoice=0,selectInvoice,selectInvoiceAddress, deliveryMethod,orderRemark,choosedPaymentMethod){
    if(!shippingAddressId) return Promise.reject({message:'shipping address is not normal：'+shippingAddressId});
    const shopIdObject = { };
    shopId.forEach((item,index)=>{
        shopIdObject[`enquiryFitsIndexArray[${index}]`] = item.id;
        shopIdObject[`enquiryFitsInfoIdArray[${index}]`] = item.id;
        shopIdObject[`orderFitsInfoDTO_ljslArray[${index}]`] = item.itemNum;
        shopIdObject[`orderFitsInfoDTO_bzArray[${index}]`] = item.partRemark;
        shopIdObject[`orderFitsInfoDTO_goodRemarkArray[${index}]`] = item.downOrderRemark;
        shopIdObject[`orderFitsInfoDTO_ljPriceArray[${index}]`] = item.itemPrice;
    })

    return requestData('/shop/order/addOrderApi','POST',{
        selectAddress:shippingAddressId,...shopIdObject,'orderInfoDTO_fpType': isNeedInvoice,selectInvoice,selectInvoiceAddress,
        orderInfoDTO_psfs:deliveryMethod,orderRemark,
        'orderInfoDTO.jsfs':choosedPaymentMethod
    });
}